import styled from "styled-components";
import { Switch } from "@mui/material";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 24px;
  margin-top: 52px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 16px;
`;

export const TimePickerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TimePickerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const TimePickerRowContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 8px;
`;

export const HolidayRowContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const HolidayPickerRowContent = styled.div<{ isActive: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 8px;
  background: ${({ isActive }) =>
    isActive ? "#FFFFFF" : "rgba(167, 167, 167, 0.15)"};
`;

export const HolidayRowPrefixContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const CustomSwitch = styled(Switch)`
  margin-left: 15px;
`;

export const ContainerButton = styled.div<{
  isActive: boolean;
  enabled?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 125px;
  gap: 5px;
  margin-left: auto;
  margin-right: 10px;
  height: 38px;
  opacity: ${({ enabled }) => (enabled ? "0.5" : "1")};
  border-radius: 4px;
  color: ${({ isActive }) => (isActive ? "#2e7d32" : "#000000")};
  background: ${({ isActive }) =>
    isActive ? "rgba(23, 188, 23, 0.15)" : "rgba(167, 167, 167, 0.15)"};
  span {
    margin-left: 0;
  }
`;

export const TimerIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const TimerIconContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(167, 167, 167, 0.15);
  border-radius: 8px;
  padding: 8px;
`;

export const ConfirmationModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 525px;
`;

export const ChipsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ConfirmationModalButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
`;

export const ConfirmationModalItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ConfirmationModalDayItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f5f5f5;
`;

export const ConfirmationModalTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
`;

export const ConfirmationModalTableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  background-color: #f5f5f5;
`;

export const ConfirmationModalTableHeaderCell = styled.div`
  padding: 12px;
  font-weight: bold;
`;

export const ConfirmationModalTableRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
`;

export const ConfirmationModalTableCell = styled.div`
  padding: 12px;
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: #fdeded;
  border: 1px solid #f5c6cb;
  border-radius: 8px;
  color: #d32f2f;
  font-size: 14px;
`;
